


( function($) {
	
	$('.chart-bar .chart-bar-part').each(function() {
		var text = $(this).data("width");
		$(this).css('width', text+"%");
	});
	
	$('.chart-bar .chart-bar-part').tooltip({
		items: "[data-name], [data-value]",
		content: function(){
			return '<h5 class="tooltip-title" style="color:'+ jQuery(this).css("background-color") + ';">'+jQuery(this).data('name')+'</h5><p class="tooltip-text" style="color:'+ jQuery(this).css("background-color") + ';">'+ jQuery(this).data('value')+'</p>'
		},
		tooltipClass:"chart-part-tooltip",
		position: {my: "top", at: "center bottom", collision:"fit none", within:$('.chart-bar')}
	    });
	
	
	jQuery( window ).ready(function() {	
	
		$('.bar .cursor').tooltip({
			placement: 'bottom',
			trigger: "manual",
			template:'<div class="tooltip" role="tooltip"><div class="tooltip-inner cursor-tooltip"></div></div>',
			}).tooltip("show");
		
		$(window).on('resize', function(){
			$('.bar .cursor').tooltip("update");
		});
	});
	
	
//	var ctx = jQuery('#cost_chart');
//	
//	if (ctx.length >0){
//		var costsdata = JSON.parse(jQuery('#cost_chart_data').val());
//		var costslabels = JSON.parse(jQuery('#cost_chart_labels').val());
//		var costscolors = JSON.parse(jQuery('#cost_chart_colors').val());
//	}

})(jQuery);

//(function() {
//	"use strict";
//
//	var supportsMultiple = self.HTMLInputElement && "valueLow" in HTMLInputElement.prototype;
//
//	var descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
//
//	self.multirange = function(input) {
//		if (supportsMultiple || input.classList.contains("multirange")) {
//			return;
//		}
//
//		var value = input.getAttribute("value");
//		var values = value === null ? [] : value.split(",");
//		var min = +(input.min || 0);
//		var max = +(input.max || 100);
//		var ghost = input.cloneNode();
//
//		input.classList.add("multirange", "original");
//		ghost.classList.add("multirange", "ghost");
//
//		input.value = values[0] || min + (max - min) / 2;
//		ghost.value = values[1] || min + (max - min) / 2;
//
//		input.parentNode.insertBefore(ghost, input.nextSibling);
//
//		Object.defineProperty(input, "originalValue", descriptor.get ? descriptor : {
//			// Fuck you Safari >:(
//			get: function() { return this.value; },
//			set: function(v) { this.value = v; }
//		});
//
//		Object.defineProperties(input, {
//			valueLow: {
//				get: function() { return Math.min(this.originalValue, ghost.value); },
//				set: function(v) { this.originalValue = v; },
//				enumerable: true
//			},
//			valueHigh: {
//				get: function() { return Math.max(this.originalValue, ghost.value); },
//				set: function(v) { ghost.value = v; },
//				enumerable: true
//			}
//		});
//
//		if (descriptor.get) {
//			// Again, fuck you Safari
//			Object.defineProperty(input, "value", {
//				get: function() { return this.valueLow + "," + this.valueHigh; },
//				set: function(v) {
//					var values = v.split(",");
//					this.valueLow = values[0];
//					this.valueHigh = values[1];
//					update();
//				},
//				enumerable: true
//			});
//		}
//
//		if (typeof input.oninput === "function") {
//			ghost.oninput = input.oninput.bind(input);
//		}
//
//		function update() {
//			ghost.style.setProperty("--low", 100 * ((input.valueLow - min) / (max - min))  + "%");
//			ghost.style.setProperty("--high", 100 * ((input.valueHigh - min) / (max - min))  + "%");
//			document.querySelectorAll(".range-display-low")[0].innerHTML = input.valueLow+"€";
//			document.querySelectorAll(".range-display-high")[0].innerHTML =  input.valueHigh+"€";
//		}
//
//		input.addEventListener("input", update);
//		ghost.addEventListener("input", update);
//
//		update();
//	}
//
//	multirange.init = function() {
//		[].slice.call(document.querySelectorAll("input[type=range][multiple]:not(.multirange)")).forEach(multirange);
//	}
//
//	if (document.readyState == "loading") {
//		document.addEventListener("DOMContentLoaded", multirange.init);
//	}
//	else {
//		multirange.init();
//	}
//
//})();

/*
 * collapse filter parameter functionnality
 * 
 */
( function(jQuery) {
	
	
	jQuery( window ).ready(function() {
		
		/* filters block hide and behaviours */
		jQuery(".filters_parameters").toggle(false);
		jQuery(".filters_display").click(function(e){ jQuery(".filters_parameters").slideToggle();});
		
		/* individual filter hide and behaviours */
		jQuery(".filter-parameter").toggle(false);
		jQuery(".filter-check").change(displayFilterParams);
		
	});
		
	function displayFilterParams(e){
		jQElt = jQuery(e.target);
		var eltClasses = jQElt.attr("class").split(/\s+/);
		for (eltClassIdx in eltClasses ){
			if (eltClasses[eltClassIdx].startsWith("filter") && (eltClasses[eltClassIdx]!='filter-check')){
				var filterParamContainer = jQuery("."+eltClasses[eltClassIdx].replace("-check","") +".filter-parameter");
				filterParamContainer.slideToggle( e.target.checked);
			}
		}
	}
	
})(jQuery);


/**
 * Building Sheet List Manager
 * 
 */

( function($) {
	
	BuildingSheetListManager = function(){
		
		var _displayNodeSelector;		
		var _filtersStatus;
		var _displayStatus;
		var _loadingElement;
		var _checkboxListStatut;
		var _currentPage;
		var _offsetTrigger;
		
		this.initialize = function initialize(displayNodeSelector){
			this.UPDATE_done = 0; 
			this.UPDATE_pending = 1; 
			this.UPDATE_running = 2; 
			this.UPDATE_error = 3;
			this._displayNodeSelector = displayNodeSelector;
			this._filtersStatus = this.UPDATE_pending;			
			this._displayStatus = this.UPDATE_pending;	
			this._currentPage = 1;
			this._checkboxListStatut={};
			
//			this._$offsetMarker =  $('.research-result-display .load-more');
//			this._scrollStatus = {
//				    allow: true,
//				    reallow: function() {
//				    	this.allow = true;
//				    },
//				    delay: 400 //(milliseconds) adjust to the highest acceptable value
//				};				
			var manager = this;
			$(".filter-parameter-value").change({manager:this}, this.updateFilter);
			$('.parameters_display input[type="radio"][name="display_type"]').change(function(){
				manager.resetPageIndex()
				manager.loadBuildingSheets();
			});			
			this.loadBuildingSheets();
			
//			$(window).scroll({manager: this},function(e){
//				var manager = e.data.manager;
//				if(manager._scrollStatus != manager.UPDATE_running) {
//					manager._scrollStatus = manager.UPDATE_running;
//					manager.manageScroll(manager);
//				}
//				});
			
			$(".load-more-action").click({manager: this}, function(e){e.data.manager.incrementPageIndex();e.data.manager.loadBuildingSheets();});
			

		}
		
		this.updateFilter = function updateFilter(e){	
			var manager = e.data.manager; 
			e.preventDefault();
			/* inhibit change trigger during update*/
			if (manager.UPDATE_running != manager._filtersStatus){
				manager._filtersStatus = manager.UPDATE_running;
				manager._checkboxListStatut={};
					
				setTimeout(function(){
					jQuery(".filter-parameter-value input[type='checkbox']:checked").each(function(idx, elt){
						manager._checkboxListStatut[jQuery(elt).attr("parameter")] = manager._checkboxListStatut[jQuery(elt).attr("parameter")] || []; 
						manager._checkboxListStatut[jQuery(elt).attr("parameter")].push(jQuery(elt).attr('id'));
					});
					
					manager._filtersStatus = manager.UPDATE_done;
					manager.resetPageIndex();
					/* Build meta Query */
					manager.loadBuildingSheets();
					
				},600);
			}
			
		};
		
		this.getDisplayType = function getDisplayType(){
			return $("input[name='display_type']:checked").val();
		};
		
		this.displayLoading = function displayLoading(){
			if ($('.building-sheet-loading').length<=0){
				loadingElement.appendTo('.building_sheet_display');
			}
			jQuery(".building-sheet-loading").fadeIn();
			
		};
		
		this.hideLoading = function hideLoading(){
			jQuery(".building-sheet-loading").fadeOut({'complete':function(){ loadingElement = jQuery(".building-sheet-loading").detach()}});
		};
		
		this.showContent = function showContent(){
			$(".research-result-display").slideDown();
		};
	
		this.hideContent = function hideContent(){
			$('.research-result-display').slideUp();
		};
		
		this.showLoadMore = function showLoadMore(){
			$('.building-sheet-load-more').show();
		}
		
		this.hideLoadMore = function hideLoadMore(){
			$('.building-sheet-load-more').hide();
		}
		
		this.incrementPageIndex = function incrementPageIndex(){
			return this._currentPage += 1;
		};
		
		this.resetPageIndex = function resetPageIndex(){
			return this._currentPage = 1;
		};
		
		this.getPageIndex = function getPageIndex(){
			return this._currentPage;
		};
		
				
		this.loadBuildingSheets = function loadBuildingSheets(){
			
			if (this._displayStatus != this.UPDATE_running){
				this._displayStatus = this.UPDATE_running;
				var manager =this;
				var metaQuery = manager._checkboxListStatut;
				ajax_object.query.post_type = "building_sheet";
				
				if (manager.getPageIndex()<=1){
					manager.hideContent();
				}		
				
				manager.displayLoading();
								
				var data = {
					action: 'building_sheet_load_more',
					display: manager.getDisplayType(),
					page: manager.getPageIndex(),
					query: ajax_object.query,
					metaQuery: metaQuery,
					nonce: ajax_object.nonce_building_sheet_load_more,
				};
				
				
				$.get(ajax_object.ajaxurl, data,function(res) {
					var selectorExt ="";
					manager.hideLoading();
					
					if( res.success) {
						if (manager.getDisplayType()==="list" && manager.getPageIndex() > 1){selectorExt = " ul"}
						
						if(1 < manager.getPageIndex()) {							
							$('.research-result-display'+selectorExt).append( res.data.html );
						} else{
							$('.research-result-display'+selectorExt).html( res.data.html );
						}
						
						if (res.data.pages_count >= manager.getPageIndex() ){
							manager.showLoadMore();
						}else{
							manager.hideLoadMore();
						} 
							
					} else {
						// console.log(res);
					}
					if (manager.getPageIndex()<=2){
						manager.showContent();
					}	
					
					manager._displayStatus = manager.UPDATE_done;
					
				}, 'json')
				.fail(function(xhr, textStatus, e) {
					// console.log(xhr.responseText);
				});
			}
			
		};
		
//		this.setListBottomMarker = function setListBottomMarker(){
//			
//			if (this._$offsetMarker.length >0){
//				loadMoreMarker = this._$offsetMarker.detach();
//				$('.research-result-display').append(loadMoreMarker)
//			}else{
//				$('.research-result-display').append( '<span class="load-more"></span>' );
//				
//			}
//			this._$offsetMarker = $('.research-result-display .load-more');
//			
//		}
		
//		this.manageScroll = function manageScroll(manager){
//			var offset = manager._$offsetMarker.offset().top - $(window).scrollTop();
//			if( manager._offsetTrigger > offset) {
//				manager.loadBuildingSheets();
//			}
//		}
		
		
	}

	
	$( document ).ready(function() {
		if ($('.building_sheet_display').length >0){
			window.buildingSheetListManager = new BuildingSheetListManager();
			window.buildingSheetListManager.initialize();
		}
	});
	
})(jQuery);	
	
	
	
	
//	var loadingElement;
//	var updateRunning;
//	
//
//	
//	function updateFilter(e){	
//		var _checkboxList = {};
//		var radicalColStr = 'filter-col-'
//		
//		/* inhibit change trigger during update*/
//		if (!updateRunning){
//			updateRunning = true;
//				
//			setTimeout(function(){
//				jQuery(".filter-parameter-value input[type='checkbox']:checked").each(function(idx, elt){
////					var filterName = jQuery(elt).parentsUntil('.row').last().attr('class').split(' ')[1];
//					_checkboxList[jQuery(elt).attr("parameter")] = _checkboxList[jQuery(elt).attr("parameter")] || []; 
//					_checkboxList[jQuery(elt).attr("parameter")].push(jQuery(elt).attr('id'));
//				});
//				
//				updateRunning = false;
//				/* Build meta Query */
//				loadBuildingSheets(_checkboxList);
//				
//			},400);
//		}
//		
//	}
	


	
	

	
	/**
	 * Infinite scroll management
	 * 
	 */
//
//	$(document).ready(function(){
//
//			var page = 2;
//			var loading = false;
//			var scrollHandling = {
//			    allow: true,
//			    reallow: function() {
//			        scrollHandling.allow = true;
//			    },
//			    delay: 400 //(milliseconds) adjust to the highest acceptable value
//			};
//		
//			$(window).scroll(function(){
//				if( ! loading && scrollHandling.allow ) {
//					scrollHandling.allow = false;
//					setTimeout(scrollHandling.reallow, scrollHandling.delay);
//					var offset = $(button).offset().top - $(window).scrollTop();
//					if( 2000 > offset ) {
//						loading = true;
//						ajax_object.query.post_type = "building_sheet";
//						var data = {
//							action: 'building_sheet_load_more',
//							display: getDisplayType(),
//							page: page,
//							query: ajax_object.query,
//							nonce: ajax_object.nonce_building_sheet_load_more, 
//						};
//						$.get(ajax_object.ajaxurl, data, function(res) {
//							if( res.success) {
//								
//								switch (getDisplayType()){
//								
//									case 'grid':
//									{
//										$('.research-result-display').append( res.data );
//										break;
//									}
//									
//									case 'list':
//									{
//										$('.research-result-display ul').append( res.data );
//										break;
//									}
//									
//									default:{
//										
//									}
//								
//								}
//								
//								$('.building_sheet_display').append( button );
//								page = page + 1;
//								loading = false;
//							} else {
//								// console.log(res);
//							}
//						}).fail(function(xhr, textStatus, e) {
//							// console.log(xhr.responseText);
//						});
//		
//					}
//				}
//			});
//		}
//	});
//});


/**
 * 
 *  goals click and hover
 * 
 * */

jQuery(document).ready(function(){
	jQuery('.table-row-details').hide();
	jQuery('.goal-list-elt').click(displayGoalDetails);
});

function displayGoalDetails(e){
	var id = jQuery(e.target).data('details');
	jQuery('.table-row-details').hide();
	jQuery('#'+id).show();
}


